module.exports = __webpack_public_path__ + "static/Mercado-c91b24a8bbe5f46b2099093cd726d084.svg";